import { useTranslation } from "react-i18next";
import { useAppConfig } from "~/app/config/useAppConfig";
import { MenuItem } from "~/common/mui";
import { SearchInputGroup } from "~/common/components/SearchInputGroup";

interface Props {
  className?: string;
  disabled?: boolean;
  value: number;
  onChange: (value: number) => void;
}

export const RadiusSelect = ({ disabled, value, onChange }: Props) => {
  const { t } = useTranslation();
  const useImperial = useAppConfig()?.configuration.spfImperial ?? false;

  const radiusDropdownMetricValues = [
    { label: "10 km", value: 10 },
    { label: "20 km", value: 20 },
    { label: "50 km", value: 50 },
    { label: "100 km", value: 100 },
    { label: "500 km", value: 500 },
    { label: t("salesPartner.searchCard.radiusLabel.unlimited"), value: -1 },
  ];

  const radiusDropdownImperialValues = [
    { label: "10 mi", value: 10 },
    { label: "20 mi", value: 20 },
    { label: "50 mi", value: 50 },
    { label: "100 mi", value: 100 },
    { label: "500 mi", value: 500 },
    { label: t("salesPartner.searchCard.radiusLabel.unlimited"), value: -1 },
  ];

  const radiusDropdownValues = useImperial ? radiusDropdownImperialValues : radiusDropdownMetricValues;

  return (
    <SearchInputGroup.Select
      value={value}
      onChange={(e) => {
        onChange(Number(e.target.value));
      }}
      disabled={disabled}
      sx={(theme) => ({
        flex: "0 0 256px",
        [theme.breakpoints.between("desktop-s", "desktop-m")]: {
          flex: "0 0 180px",
        },
      })}
    >
      {radiusDropdownValues.map((radius) => (
        <MenuItem key={radius.value} value={radius.value}>
          {radius.label}
        </MenuItem>
      ))}
    </SearchInputGroup.Select>
  );
};
